'use client';

import { EcEnv } from '@castlery/config';
import { Badge, IconButton, Stack, Toast, Typography, useBreakpoints } from '@castlery/fortress';
import { CheckCircleFilled, Close, Favorite } from '@castlery/fortress/Icons';
import { removeFromWishlist } from '@castlery/modules-cms-services';
import {
  getTheLookWishListSelect,
  getWishListSelect,
  initWishList,
  removeWishListItem,
  selectedTempRemoveWishListItemInfo,
  selectedTheLookWishList,
  selectedWishList,
  selectedWishlistActionRecord,
  updateTempRemoveWishListItemInfo,
} from '@castlery/modules-user-domain';
import { CustomLink } from '@castlery/shared-components';
import { useAppDispatch, useAppSelector } from '@castlery/shared-redux-store';
import { useCallback, useEffect, useRef, useState } from 'react';
import LinkButton from '../link-button/link-button';

const FavoriteButton = () => {
  const dispatch = useAppDispatch();
  // const pageMap = useAppSelector(selectPageMap);
  const { isLoading: wishListIsLoading } = useAppSelector(getWishListSelect());
  const { isLoading: theLookWishListIsLoading } = useAppSelector(getTheLookWishListSelect());
  const currentWishListData = useAppSelector(selectedWishList);
  const currentTheLookWishListData = useAppSelector(selectedTheLookWishList);
  const wishlistActionRecord = useAppSelector(selectedWishlistActionRecord);
  const tempRemoveWishListItemInfo = useAppSelector(selectedTempRemoveWishListItemInfo);
  const lastTempRemoveWishListItemInfoRef = useRef({
    name: '',
    id: 0,
  });

  const [isToastOpen, setIsToastOpen] = useState(false);
  const [isTempRemoveToastOpen, setIsTempRemoveToastOpen] = useState(false);
  const [countDown, setCountDown] = useState(5);
  const countDownTimerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const [toastStatus, setToastStatus] = useState<'add' | 'remove'>('add');
  const { desktop } = useBreakpoints();
  // 添加初始化标志
  const [isInitialized, setIsInitialized] = useState(false);

  const firstInitWishList = useCallback(async () => {
    await dispatch(initWishList());
    setIsInitialized(true);
  }, [dispatch]);

  useEffect(() => {
    if (!isInitialized) {
      firstInitWishList();
    }
  }, [dispatch, isInitialized, firstInitWishList]);

  // const onCurrentWishListLengthChange = (status: 'add' | 'remove' | 'init') => {
  //   let toastShow = false;
  //   if (status === 'add') {
  //     // setToastStatus('add');
  //     // toastShow = true;
  //   } else if (status === 'remove') {
  //     setToastStatus('remove');
  //     toastShow = true;
  //   }
  //   // if (toastShow) {
  //   //   setIsToastOpen(true);
  //   //   setTimeout(() => {
  //   //     setIsToastOpen(false);
  //   //   }, 3000);
  //   // }
  // };

  // useEffect(() => {
  //   onCurrentWishListLengthChange(wishlistActionRecord);
  // }, [wishlistActionRecord, currentWishListData.length]);

  // useEffect(() => {
  //   if (tempRemoveWishListItemInfo.name && desktop) {
  //     if (
  //       lastTempRemoveWishListItemInfoRef.current.name !== tempRemoveWishListItemInfo.name &&
  //       lastTempRemoveWishListItemInfoRef.current.name !== ''
  //     ) {
  //       removeFromWishlist({ id: lastTempRemoveWishListItemInfoRef.current.id });
  //       dispatch(removeWishListItem(lastTempRemoveWishListItemInfoRef.current.id));
  //     }
  //     lastTempRemoveWishListItemInfoRef.current = {
  //       name: tempRemoveWishListItemInfo.name || '',
  //       id: tempRemoveWishListItemInfo.id || 0,
  //     };
  //     setIsTempRemoveToastOpen(true);
  //     if (countDownTimerRef.current) {
  //       clearInterval(countDownTimerRef.current);
  //       countDownTimerRef.current = null;
  //     }
  //     setCountDown(5);
  //     countDownTimerRef.current = setInterval(() => {
  //       setCountDown((prev) => {
  //         if (prev <= 1) {
  //           if (countDownTimerRef.current) {
  //             if (tempRemoveWishListItemInfo.id) {
  //               removeFromWishlist({ id: tempRemoveWishListItemInfo.id });
  //               dispatch(removeWishListItem(tempRemoveWishListItemInfo.id));
  //               lastTempRemoveWishListItemInfoRef.current = {
  //                 name: '',
  //                 id: 0,
  //               };
  //               setIsTempRemoveToastOpen(false);
  //             }
  //             clearInterval(countDownTimerRef.current);
  //             countDownTimerRef.current = null;
  //           }
  //           return 0;
  //         }
  //         return prev - 1;
  //       });
  //     }, 1000);
  //   }

  //   return () => {
  //     if (countDownTimerRef.current) {
  //       clearInterval(countDownTimerRef.current);
  //       countDownTimerRef.current = null;
  //     }
  //   };
  // }, [tempRemoveWishListItemInfo.name]);

  return (
    <>
      <IconButton
        size="md"
        component={LinkButton}
        path={`/${EcEnv.NEXT_PUBLIC_COUNTRY.toLocaleLowerCase()}/wishlist`}
        menu-type="user_menu"
        text="Wishlist"
        aria-label="Wishlist"
      >
        <Badge loading={wishListIsLoading || theLookWishListIsLoading} badgeContent={currentWishListData.length}>
          <Favorite
            sx={(theme) => ({
              width: theme.spacing(6),
              height: theme.spacing(6),
              color: theme.palette.brand.mono[900],
            })}
          />
        </Badge>
      </IconButton>
      {/* <Toast
        open={isToastOpen}
        theme="dark"
        sx={{
          position: 'fixed',
          left: '87%',
          bottom: '83%',
          width: toastStatus === 'add' ? '368px' : '312px',
          padding: '16px',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        startDecorator={<CheckCircleFilled />}
        endDecorator={<Close onClick={() => setIsToastOpen(false)} sx={{ cursor: 'pointer' }} />}
      >
        <Stack
          direction="row"
          alignItems="center"
          sx={(theme) => ({
            width: 'fit-content',
            a: {
              textDecorationColor: theme.palette.brand.warmLinen[500],
            },
          })}
        >
          <Typography
            sx={(theme) => ({
              color: theme.palette.brand.warmLinen[500],
              marginRight: '8px',
              fontSize: '16px',
            })}
          >
            {toastStatus === 'add' ? 'Added to wishlist!' : 'Removed from wishlist!'}
          </Typography>
          {toastStatus === 'add' && (
            <CustomLink linkKey="wishlist">
              <Typography
                sx={{
                  color: '#F6F3E7',
                  fontSize: '16px',
                }}
              >
                View Wishlist
              </Typography>
            </CustomLink>
          )}
        </Stack>
      </Toast> */}
      {/* <Toast
        open={isTempRemoveToastOpen}
        theme="dark"
        sx={(theme) => ({
          position: 'fixed',
          bottom: theme.spacing(15),
          width: 'fit-content',
          padding: '16px',
        })}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          sx={(theme) => ({
            width: 'fit-content',
            a: {},
          })}
        >
          <Typography>{tempRemoveWishListItemInfo.name} has been removed from your wishlist.</Typography>
          <Typography
            sx={(theme) => ({
              color: theme.palette.brand.warmLinen[500],
              marginRight: '8px',
              fontSize: '16px',
              textDecorationColor: theme.palette.brand.warmLinen[500],
              textDecoration: 'underline',
              cursor: 'pointer',
            })}
            onClick={(e) => {
              if (countDownTimerRef.current) {
                clearInterval(countDownTimerRef.current);
                countDownTimerRef.current = null;
              }
              setIsTempRemoveToastOpen(false);
              lastTempRemoveWishListItemInfoRef.current = {
                name: '',
                id: 0,
              };
              dispatch(updateTempRemoveWishListItemInfo({ name: '', id: 0 }));
            }}
          >
            {`Undo (0:0${countDown})`}
          </Typography>
        </Stack>
      </Toast> */}
    </>
  );
};

export { FavoriteButton };
